import { render, staticRenderFns } from "./ArpFillReserva.vue?vue&type=template&id=70bb6e35&scoped=true&"
import script from "./ArpFillReserva.vue?vue&type=script&lang=js&"
export * from "./ArpFillReserva.vue?vue&type=script&lang=js&"
import style0 from "./ArpFillReserva.vue?vue&type=style&index=0&id=70bb6e35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bb6e35",
  null
  
)

export default component.exports